import { usePastCustomers } from '@/api/b2b/getOpportunities';
import { useSnoozeCustomer } from '@/api/b2b/snooze';
import { CustomerOpportunityColumn } from './CustomerOpportunityColumn';

export const PastCustomersColumn = () => (
  <CustomerOpportunityColumn
    useData={usePastCustomers}
    useSnooze={useSnoozeCustomer}
    testid="b2b-past-customers"
    title="Past Customer Outreach"
    subtitle="Repeat B2B — anniversary window approaching"
    emptyLabel="No past customers due right now."
    linkBase="/customers/customer"
  />
);
